import { Button, ButtonIcon, ButtonText } from "@/components/ui/button";
import { ChevronDownIcon } from "@/components/ui/icon";
import { HStack } from "@/components/ui/hstack";
import { Icon } from "@/components/ui/icon";
import { Select, SelectBackdrop, SelectContent, SelectDragIndicator, SelectDragIndicatorWrapper, SelectIcon, SelectInput, SelectItem, SelectPortal, SelectTrigger } from "@/components/ui/select";
import { Text } from "@/components/ui/text";
import {
    Popover,
    PopoverBackdrop,
    PopoverContent,
} from "@/components/ui/popover";
import {MaterialCommunityIcons} from "@expo/vector-icons";
import {useEffect, useState} from "react";


export default function LanguageLevelButton({ filterValue, setFilterValue=(value)=>{}, onDelete=()=>{}, openOnMount=false }) {

    const [isOpen, setIsOpen] = useState(false)
    const [value, setValue] = useState(null)
    const levels = [
        {key: "normal", label: "Alltagssprache"},
        {key: "easy", label: "Einfache Sprache"},
    ]

    useEffect(() => {
        setIsOpen(openOnMount)
    }, [])

    useEffect(() => {
        console.log("LanguageLevel filterValue")
        console.log(filterValue)
        setValue(filterValue)
    }, [filterValue])

    return (<Popover
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        placement='top left'
        offset={10}
        unmountOnExit
        trigger={({ ...triggerProps }) => (
            <Button
                {...triggerProps}
                size="sm"
                className={`group w-9 h-9 rounded-full items-center justify-center bg-transparent border border-primary-900
                    overflow-hidden ${filterValue ? 'bg-primary-900' : 'bg-transparent'}`}
            >
                <ButtonIcon
                    as={MaterialCommunityIcons}
                    name="signal-cellular-3"
                    size={18}
                    className={`${filterValue ? 'text-white' : 'text-primary-900'} group-hover:text-white`}
                />
            </Button>
        )}
    >
        <PopoverBackdrop className='bg-transparent' />
        <PopoverContent className='bg-white p-3.5 w-auto gap-3 rounded-md border border-transparent shadow-lg'>
            <Text className='font-semibold'>Sprachniveau</Text>

            <Select
                initialLabel={value ? levels.find(l => l.key === value)?.label : null}
                selectedValue={levels.find(l => l.key === value)?.key}
                onValueChange={(value) => setValue(value)}
            >
                <SelectTrigger className="border border-secondary-300 rounded-md h-9 px-0 flex-row items-center justify-between">
                    <SelectInput placeholder="Wählen..." />
                    <SelectIcon as={ChevronDownIcon} className="mr-1" />
                </SelectTrigger>

                <SelectPortal>
                    <SelectBackdrop />
                    <SelectContent>
                        <SelectDragIndicatorWrapper>
                            <SelectDragIndicator />
                        </SelectDragIndicatorWrapper>
                        {
                            levels.map((level) => (<SelectItem
                                key={level.key}
                                value={level.key}
                                label={level.label}
                            />))
                        }
                    </SelectContent>
                </SelectPortal>
            </Select>

            <HStack className='gap-2 justify-between'>
                <Button className='flex-1 h-[34px] bg-primary-900 px-7' onPress={() => {setFilterValue(value); setIsOpen(false)}}>
                    <ButtonText>Auswählen</ButtonText>
                </Button>
                <Button className='h-[34px] bg-error-600 px-3' onPress={onDelete}>
                    <ButtonIcon as={MaterialCommunityIcons} name='trash-can' className='text-white' size={18} />
                </Button>
            </HStack>
        </PopoverContent>
    </Popover>)

}
